import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import {CompanySandbox} from '../../../modules/global';
import {Observable} from 'rxjs';
import {filter, map, shareReplay} from 'rxjs/operators';
import { PageContainerComponent } from '../../../modules/shared/components/page-container/page-container.component';
import { TitledCardComponent } from '../../../modules/shared/components/titled-card/titled-card.component';
import { SvgIconComponent } from 'angular-svg-icon';
import { TranslateDirective } from '@ngx-translate/core';
import { StepperComponent } from '../../../modules/shared/components/stepper/stepper.component';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'slm-component-pending',
    templateUrl: './company-pending.container.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PageContainerComponent, TitledCardComponent, SvgIconComponent, TranslateDirective, StepperComponent, NgIf, AsyncPipe]
})
export class CompanyPendingContainer implements OnInit {
  private readonly companySandbox = inject(CompanySandbox);

  public statuses$: Observable<Array<string>>;
  public currentStep = 0;
  public description: string;
  public companyName$: Observable<string>;

  ngOnInit() {
    this.statuses$ = this.companySandbox.getCompanyActivation().pipe(
      filter((companies) => !!companies?.items?.length),
      map((companies) => companies?.items ?? []),
      map((steps) => {
        this.currentStep = steps.findIndex((step) => !step.checked);
        this.description = steps[this.currentStep]?.description || '';
        return steps.map((step) => step.text);
      }),
      shareReplay({
        bufferSize: 1,
        refCount: true
      })
    );

    this.companyName$ = this.companySandbox.activeCompany$.pipe(
      map(company => company?.partnerName ? company.partnerName : '')
    );
  }
}
